import { dateFromState } from "../../../Helpers/DateTimeHelper";

/**
 * Remove elapsed bookings once end time has passed
 * and signed out bookings, but keep bookigns which
 * are still signed in and not signed out yet
 * @param bookings
 * @returns {{[p: string]: unknown}}
 */
export const removeElapsedBookings = (bookings) => {
    const now = new Date();

    return Object.fromEntries(
        Object.entries(bookings)
            .filter(([id, booking]) => {
                let bookingEnd = dateFromState(booking.end);

                if (booking.sign_in_enabled) {
                    if (bookingEnd > now && !booking.signed_out_at) {
                        return true;
                    }

                    if (booking.sign_in_enabled && booking.signed_in_at && !booking.signed_out_at) {
                        return true;
                    }
                } else {
                    if (bookingEnd > now) {
                        return true;
                    }
                }

                return false
        }))
}
